import _ from 'lodash'

const isCategoryLoading = (state) => _.get(state, 'loading')
const categories = (state) => _.get(state, 'categories')
const errors = (state) => _.get(state, 'errors')
const selectedCategory = (state) => _.get(state, 'selectedCategory')

export default {
	isCategoryLoading,
	categories,
	errors,
	selectedCategory,
}
